import axios from "axios";
import {useEffect, useState} from 'react';
import config from "../config";
import user_icon from '../img/icon/user-icon.svg';


const InterestedUsersInOwnClothesDisplay = ({user, clickedOwnClothes, setClickedUser}) => {
    const [interestedUsers, setInterestedUsers] = useState([])
    const clickedClothesId = clickedOwnClothes?._id
    const getInterestedUsers = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}matchedUsers`,{
                headers: {"token": localStorage.getItem("token")},
                params: {clothes_id: clickedClothesId}
            })
            setInterestedUsers(response.data)

        }
        catch (error){
            console.log(error)
        }

    }

    useEffect(() => {
        getInterestedUsers();
    }, []);
    
    if (interestedUsers !== undefined && interestedUsers.length===0){
        setInterestedUsers(undefined);
    }
    return(
        <div className="matches-display">
            {interestedUsers ? interestedUsers?.map((match, _index) => (
                <div
                    key={_index}
                    className="match-card"
                    onClick={() => setClickedUser(match)
                    }
                >
                    
                    <div className="img-container">
                        <img src={match.pic ? match.pic : user_icon} alt={"interested user profile picture"} />
                    </div>
                </div>
            )):<p>Bisher gibt es noch keine interessierte User</p>}
        </div>
    )
}
export default InterestedUsersInOwnClothesDisplay